import UserApi from "../data/UserApi";
import * as ActionTypes from "./ActionTypes";

export function loginUser(user) {
    //console.log("loginUser");
    return function (dispatch) {
        return UserApi.loginUser(user, (userData) => 
            dispatch({
                type: ActionTypes.LOGIN_USER,
                userData: userData,
            })
        )
    }
}

export function signupUser(user) {
    //console.log("signupUser");
    return function (dispatch) {
        return UserApi.signupUser(user, (userData) => 
            dispatch({
                type: ActionTypes.SIGNUP_USER,
                userData: userData,
            })
        )
    }
}

export function logoutUser() {
    //console.log("logoutUser");
    return function (dispatch) {
        return dispatch({
            type: ActionTypes.LOGOUT_USER,
        })
    }
}